import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { nivelesAdminApi } from '@/data/api/nivelesAdminApi';
const KEY = 'niveles-admin';
const VALORES_KEY = 'niveles-valores';
export function useNivelesDeDisciplinaAdmin(clave) {
    return useQuery({
        queryKey: [KEY, clave],
        queryFn: () => nivelesAdminApi.listarPorDisciplina(clave),
        enabled: Boolean(clave),
    });
}
export function useCrearNivel() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => nivelesAdminApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEditarNivel() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => nivelesAdminApi.editar(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarNivel() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => nivelesAdminApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useValoresDeNivel(nivelId) {
    return useQuery({
        queryKey: [VALORES_KEY, nivelId],
        queryFn: () => nivelesAdminApi.listarValores(nivelId),
        enabled: Boolean(nivelId),
    });
}
export function useCrearValorNivel(nivelId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => nivelesAdminApi.crearValor(nivelId, v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [VALORES_KEY, nivelId] }),
    });
}
export function useCerrarValorNivel(nivelId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ valorId, hasta }) => nivelesAdminApi.cerrarValor(valorId, hasta),
        onSuccess: () => qc.invalidateQueries({ queryKey: [VALORES_KEY, nivelId] }),
    });
}
